import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react'

import { globalCss } from './globalCss'
import { layerStyles } from './layerStyles'
import { recipes } from './recipes'
import { semanticTokens } from './semanticTokens'
import { textStyles } from './textStyles'
import { breakpoints, tokens } from './tokens'

const config = defineConfig({
  cssVarsPrefix: 'or',
  globalCss,
  theme: {
    breakpoints,
    tokens,
    semanticTokens,
    textStyles,
    layerStyles,
    recipes,
  },
})

export const system = createSystem(defaultConfig, config)
